import React from "react";
import phoneImg from "../../assets/images/feature1.webp";
import "./dailyreflections.css";

export default function DailyReflections() {
  return (
    <section className="dailyreflections-section">
      <div className="dailyreflections-container">
        {/* Left: Phone image */}
        <img
          src={phoneImg}
          alt="Horoscope on phone"
          className="dailyreflections-image"
          loading="lazy"
        />
        {/* Right: Text */}
        <div className="dailyreflections-content">
          <h5 className="dailyreflections-title">
            For Your Everyday Moments
          </h5>
          <h2 className="dailyreflections-heading">
            Personalised Daily <br /> Horoscope
          </h2>
          <p className="dailyreflections-description">
            Millions share your zodiac, but your life is unique. Get a personalised daily horoscope you can trust, based on your unique birth chart, not zodiac.
          </p>
        </div>
      </div>
    </section>
  );
}
